/**
 * Custom icon list
 * All icons are loaded here for easy management
 * @see https://vue.ant.design/components/icon/#Custom-Font-Icon
 *
 * 自定义图标加载表
 * 所有图标均从这里加载，方便管理
 */
import bxAnaalyse from '@/assets/icons/bx-analyse.svg?inline' // path to your '*.svg?inline' file.
import bug404Icon from '@/assets/icons/svg/404.svg?inline'
import bugIcon from '@/assets/icons/svg/bug.svg?inline'
import buildIcon from '@/assets/icons/svg/build.svg?inline'
import buttonIcon from '@/assets/icons/svg/button.svg?inline'
import cascaderIcon from '@/assets/icons/svg/cascader.svg?inline'
import chartIcon from '@/assets/icons/svg/chart.svg?inline'
import checkboxIcon from '@/assets/icons/svg/checkbox.svg?inline'
import clientIcon from '@/assets/icons/svg/client.svg?inline'
import clipboardIcon from '@/assets/icons/svg/clipboard.svg?inline'
import codeIcon from '@/assets/icons/svg/code.svg?inline'
import colorIcon from '@/assets/icons/svg/color.svg?inline'
import componentIcon from '@/assets/icons/svg/component.svg?inline'
import dashboardIcon from '@/assets/icons/svg/dashboard.svg?inline'
import daterangeIcon from '@/assets/icons/svg/date-range.svg?inline'
import dateIcon from '@/assets/icons/svg/date.svg?inline'
import dictIcon from '@/assets/icons/svg/dict.svg?inline'
import documentationIcon from '@/assets/icons/svg/documentation.svg?inline'
import downloadIcon from '@/assets/icons/svg/download.svg?inline'
import dragIcon from '@/assets/icons/svg/drag.svg?inline'
import druidIcon from '@/assets/icons/svg/druid.svg?inline'
import editIcon from '@/assets/icons/svg/edit.svg?inline'
import educationIcon from '@/assets/icons/svg/education.svg?inline'
import emailIcon from '@/assets/icons/svg/email.svg?inline'
import exampleIcon from '@/assets/icons/svg/example.svg?inline'
import excelIcon from '@/assets/icons/svg/excel.svg?inline'
import exitfullscreenIcon from '@/assets/icons/svg/exit-fullscreen.svg?inline'
import eyeopenIcon from '@/assets/icons/svg/eye-open.svg?inline'
import eyeIcon from '@/assets/icons/svg/eye.svg?inline'
import formIcon from '@/assets/icons/svg/form.svg?inline'
import fullscreenIcon from '@/assets/icons/svg/fullscreen.svg?inline'
import githubIcon from '@/assets/icons/svg/github.svg?inline'
import guideIcon from '@/assets/icons/svg/guide.svg?inline'
import iconIcon from '@/assets/icons/svg/icon.svg?inline'
import inputIcon from '@/assets/icons/svg/input.svg?inline'
import internationalIcon from '@/assets/icons/svg/international.svg?inline'
import jobIcon from '@/assets/icons/svg/job.svg?inline'
import languageIcon from '@/assets/icons/svg/language.svg?inline'
import linkIcon from '@/assets/icons/svg/link.svg?inline'
import listIcon from '@/assets/icons/svg/list.svg?inline'
import lockIcon from '@/assets/icons/svg/lock.svg?inline'
import logIcon from '@/assets/icons/svg/log.svg?inline'
import logininforIcon from '@/assets/icons/svg/logininfor.svg?inline'
import messageIcon from '@/assets/icons/svg/message.svg?inline'
import moneyIcon from '@/assets/icons/svg/money.svg?inline'
import monitorIcon from '@/assets/icons/svg/monitor.svg?inline'
import nacosIcon from '@/assets/icons/svg/nacos.svg?inline'
import nestedIcon from '@/assets/icons/svg/nested.svg?inline'
import numberIcon from '@/assets/icons/svg/number.svg?inline'
import onlineIcon from '@/assets/icons/svg/online.svg?inline'
import passwordIcon from '@/assets/icons/svg/password.svg?inline'
import pdfIcon from '@/assets/icons/svg/pdf.svg?inline'
import peopleIcon from '@/assets/icons/svg/people.svg?inline'
import peoplesIcon from '@/assets/icons/svg/peoples.svg?inline'
import phoneIcon from '@/assets/icons/svg/phone.svg?inline'
import postIcon from '@/assets/icons/svg/post.svg?inline'
import qqIcon from '@/assets/icons/svg/qq.svg?inline'
import questionIcon from '@/assets/icons/svg/question.svg?inline'
import radioIcon from '@/assets/icons/svg/radio.svg?inline'
import rateIcon from '@/assets/icons/svg/rate.svg?inline'
import rowIcon from '@/assets/icons/svg/row.svg?inline'
import searchIcon from '@/assets/icons/svg/search.svg?inline'
import selectIcon from '@/assets/icons/svg/select.svg?inline'
import sentinelIcon from '@/assets/icons/svg/sentinel.svg?inline'
import serverIcon from '@/assets/icons/svg/server.svg?inline'
import shoppingIcon from '@/assets/icons/svg/shopping.svg?inline'
import sizeIcon from '@/assets/icons/svg/size.svg?inline'
import skillIcon from '@/assets/icons/svg/skill.svg?inline'
import sliderIcon from '@/assets/icons/svg/slider.svg?inline'
import starIcon from '@/assets/icons/svg/star.svg?inline'
import swaggerIcon from '@/assets/icons/svg/swagger.svg?inline'
import switchIcon from '@/assets/icons/svg/switch.svg?inline'
import systemIcon from '@/assets/icons/svg/system.svg?inline'
import tabIcon from '@/assets/icons/svg/tab.svg?inline'
import tableIcon from '@/assets/icons/svg/table.svg?inline'
import textareaIcon from '@/assets/icons/svg/textarea.svg?inline'
import themeIcon from '@/assets/icons/svg/theme.svg?inline'
import timerangeIcon from '@/assets/icons/svg/time-range.svg?inline'
import timeIcon from '@/assets/icons/svg/time.svg?inline'
import toolIcon from '@/assets/icons/svg/tool.svg?inline'
import treetableIcon from '@/assets/icons/svg/tree-table.svg?inline'
import treeIcon from '@/assets/icons/svg/tree.svg?inline'
import uploadIcon from '@/assets/icons/svg/upload.svg?inline'
import userIcon from '@/assets/icons/svg/user.svg?inline'
import validCodeIcon from '@/assets/icons/svg/validCode.svg?inline'
import wechatIcon from '@/assets/icons/svg/wechat.svg?inline'
import zipIcon from '@/assets/icons/svg/zip.svg?inline'

const all = {
    bxAnaalyse,
    bug404Icon,
    bugIcon,
    buildIcon,
    buttonIcon,
    cascaderIcon,
    chartIcon,
    checkboxIcon,
    clientIcon,
    clipboardIcon,
    codeIcon,
    colorIcon,
    componentIcon,
    dashboardIcon,
    daterangeIcon,
    dateIcon,
    dictIcon,
    documentationIcon,
    downloadIcon,
    dragIcon,
    druidIcon,
    editIcon,
    educationIcon,
    emailIcon,
    exampleIcon,
    excelIcon,
    exitfullscreenIcon,
    eyeopenIcon,
    eyeIcon,
    formIcon,
    fullscreenIcon,
    githubIcon,
    guideIcon,
    iconIcon,
    inputIcon,
    internationalIcon,
    jobIcon,
    languageIcon,
    linkIcon,
    listIcon,
    lockIcon,
    logIcon,
    logininforIcon,
    messageIcon,
    moneyIcon,
    monitorIcon,
    nacosIcon,
    nestedIcon,
    numberIcon,
    onlineIcon,
    passwordIcon,
    pdfIcon,
    peopleIcon,
    peoplesIcon,
    phoneIcon,
    postIcon,
    qqIcon,
    questionIcon,
    radioIcon,
    rateIcon,
    rowIcon,
    searchIcon,
    selectIcon,
    sentinelIcon,
    serverIcon,
    shoppingIcon,
    sizeIcon,
    skillIcon,
    sliderIcon,
    starIcon,
    swaggerIcon,
    switchIcon,
    systemIcon,
    tabIcon,
    tableIcon,
    textareaIcon,
    themeIcon,
    timerangeIcon,
    timeIcon,
    toolIcon,
    treetableIcon,
    treeIcon,
    uploadIcon,
    userIcon,
    validCodeIcon,
    wechatIcon,
    zipIcon
}

export default all
